import { render, staticRenderFns } from "./RunnitBoardMemberJoinedStatus.vue?vue&type=template&id=15bdef83"
import script from "./RunnitBoardMemberJoinedStatus.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardMemberJoinedStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports